export const data = {
  en: {
    paragraphs: [
      {
        title: 'Privacy Policy of the Institute for Vocational Training e.V.',
        text: 'The use of the web pages is usually possible without providing personal data. As far as on our sides personal data (such as name or e-mail addresses, etc.) are collected, this is done, as far as possible, always on a voluntary basis. These data will not be disclosed to third parties without your explicit consent. ',
      },
      {
        title: '',
        text: 'We treat your personal data confidentially. The operator of these pages takes the protection of your personal data very seriously. ',
      },
      {
        title: 'Cookies',
        text: 'The websites do not use cookies over time so that your data can not be stored on our servers.',
      },
    ],
  },
  de: {
    paragraphs: [
      {
        title: 'Datenschutzerklärung des Instituts für Berufsbildung e.V.',
        text: 'Die Nutzung der Webseiten ist in der Regel ohne Angabe von personenbezogenen Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (wie z.B. Name oder E-Mail-Adressen usw.) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden nicht an Dritte ohne Ihre ausdrückliche Zustimmung weitergegeben.',
      },
      {
        title: '',
        text: 'Wir behandeln Ihre personenbezogenen Daten vertraulich. Der Betreiber dieser Seiten nimmt den Schutz Ihrer persönlichen Daten sehr ernst.',
      },
      {
        title: 'Cookies',
        text: 'Die Internetseiten verwenden der Zeit keine Cookies, sodass Ihre Daten nicht auf unsere Server gespeichert werden können.',
      },
    ],
  },
};